module.exports = __webpack_public_path__ + "img/logo.56162ec4.png";